import type { JSX } from "react";
import { EditablePhoneNumber, QuickConnectLabel, VdnName } from "@/common-ui";
import type { Contact } from "@/shared-types";
import { extractNumbers, removeCountryCode, tryGetByVdnDestination, tryGetByVdnNumber } from "@/shared-utils";
import { useContactsStateStore } from "../../../TransferCall/vdnContacts.store";

interface ParticipantInfoProps {
    mdn: string;
    customerLeft?: boolean;
    quickConnectName?: string | undefined;
}

export function ParticipantLabel({ mdn, customerLeft, quickConnectName }: ParticipantInfoProps): JSX.Element {
    const { contacts } = useContactsStateStore();

    if (quickConnectName) {
        return <QuickConnectLabel quickConnectName={quickConnectName} />;
    }

    function tryGetVdn(cleanedNumber: string, contacts: Contact[]) {
        return tryGetByVdnNumber(cleanedNumber, contacts) ?? tryGetByVdnDestination(cleanedNumber, contacts);
    }

    const vdn = tryGetVdn(extractNumbers(removeCountryCode(mdn)), contacts);

    return vdn ? (
        <VdnName vdn={vdn} data-testid="participant-vdn-name" />
    ) : (
        <EditablePhoneNumber mdn={mdn} customerLeft={customerLeft} data-testid="participant-editable-phone-number" />
    );
}
